import React, { useState } from 'react';
import { Alert, Link } from '@one-thd/sui-atomic-components';
import { bool, func, shape, string } from 'prop-types';

const BundleAlertmessage = ({
  alertSize,
  alertBodyText,
  alertHeadline,
  status,
  navigateToPackage,
  shopMoreLinkText,
  showCloseAlertButton
}) => {
  const [closeAlert, setCloseAlert] = useState(false);

  if (closeAlert) { return null; }

  return (
    <div data-testid="BundleAlertmessage">
      <Alert
        status={status}
        size={alertSize}
        headline={alertHeadline}
        onClose={showCloseAlertButton ? () => {
          setCloseAlert(true);
        } : null}
      >
        <div>
          {alertBodyText}
          {shopMoreLinkText && (
            <Link
              component="button"
              onClick={navigateToPackage}
              variant="body-xs"
            >
              {shopMoreLinkText}
            </Link>
          )}
        </div>
      </Alert>
    </div>
  );
};

BundleAlertmessage.propTypes = {
  alertSize: string,
  alertBodyText: string,
  alertHeadline: string,
  status: string,
  navigateToPackage: func,
  shopMoreLinkText: string,
  showCloseAlertButton: bool
};

BundleAlertmessage.defaultProps = {
  alertBodyText: null,
  alertHeadline: null,
  alertSize: 'small',
  status: 'success',
  navigateToPackage: () => { },
  shopMoreLinkText: null,
  showCloseAlertButton: false
};

BundleAlertmessage.displayName = 'BundleAlertmessage';

export { BundleAlertmessage };